import { render, staticRenderFns } from "./CurrencyOdometer.vue?vue&type=template&id=59c56fd4&scoped=true&"
import script from "./CurrencyOdometer.vue?vue&type=script&lang=js&"
export * from "./CurrencyOdometer.vue?vue&type=script&lang=js&"
import style0 from "./CurrencyOdometer.vue?vue&type=style&index=0&id=59c56fd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c56fd4",
  null
  
)

export default component.exports